export default {
  label: 'Publikation.form.publikationsTyp',
  field: 'publikationsTyp',
  type: 'select',
  translatable: true,
  values: [
    {
      value: 'ARTIKEL',
      label: 'PublikationsTyp.ARTIKEL'
    },
    {
      value: 'SAMMELBANDBEITRAG',
      label: 'PublikationsTyp.SAMMELBANDBEITRAG'
    },
    {
      value: 'TAGUNGSBEITRAG',
      label: 'PublikationsTyp.TAGUNGSBEITRAG'
    },
    {
      value: 'BUCHBEITRAG',
      label: 'PublikationsTyp.BUCHBEITRAG'
    },
    {
      value: 'SAMMELBAND',
      label: 'PublikationsTyp.SAMMELBAND'
    },
    {
      value: 'TAGUNGSBAND',
      label: 'PublikationsTyp.TAGUNGSBAND'
    },
    {
      value: 'SONDERHEFT',
      label: 'PublikationsTyp.SONDERHEFT'
    },
    {
      value: 'MONOGRAPHIE',
      label: 'PublikationsTyp.MONOGRAPHIE'
    },
    {
      value: 'QUELLENEDITION',
      label: 'PublikationsTyp.QUELLENEDITION'
    },
    {
      value: 'BERICHT',
      label: 'PublikationsTyp.BERICHT'
    },
    {
      value: 'WORKINGPAPER',
      label: 'PublikationsTyp.WORKINGPAPER'
    },
    {
      value: 'BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN',
      label: 'PublikationsTyp.BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN'
    },
    {
      value: 'DISSERTATION',
      label: 'PublikationsTyp.DISSERTATION'
    },
    {
      value: 'HABILITATIONSSCHRIFT',
      label: 'PublikationsTyp.HABILITATIONSSCHRIFT'
    },
    {
      value: 'SONSTIGE',
      label: 'PublikationsTyp.SONSTIGE'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/PublikationsTyp.js